<div class="bg-white p-6 rounded-xl flex flex-col gap-6">
  <div class="flex items-center gap-3">
    <icon [name]="'tabs'" [size]="'1.875rem'" />
    <h4>{{ 'components.journeyBreadcrumbs.title' | transloco }}</h4>
  </div>
  <div
    class="flex flex-col md:flex-row gap-2 md:gap-0 items-center justify-between overflow-x-auto flex-no-wrap max-h-[12.5rem]"
  >
    @for (page of currentJourney(); track $index; let index = $index;let last =
    $last; let first = $first) {
    <div class="flex flex-1 flex-col gap-2 items-center">
      <div class="flex items-center w-full">
        @if(!first) {
        <div
          class="flex-1 h-[0.125rem] w-[1.25rem] bg-vinciBlue-600 rounded-r-xl mr-2 mobile-hidden"
        ></div>
        } @else {
        <div class="flex-1 mobile-hidden"></div>
        }
        <button
          class="rounded-full px-4 py-1 bg-vinciGrey-100 text-vinciBlue-600 text-[1.5rem] self-center m-auto hover:cursor-pointer hover:bg-vinciBlue-600 hover:text-white transition-colors duration-300"
          [class.!bg-vinciBlue-600]="isTheCurrentPage(page.route)"
          [class.!text-white]="isTheCurrentPage(page.route)"
          (click)="redirectTo(page.route)"
        >
          {{index}}
        </button>
        @if(!last) {
        <div
          class="flex-1 h-[0.125rem] w-[1.25rem] bg-vinciBlue-600 rounded-l-xl ml-2 mobile-hidden"
        ></div>
        }@else {
        <div class="flex-1 mobile-hidden"></div>
        }
      </div>

      <p
        class="w-fit text-vinciGrey-600 whitespace-nowrap"
        [class.!font-bold]="isTheCurrentPage(page.route)"
        [class.!text-black]="isTheCurrentPage(page.route)"
      >
        {{page.title | transloco}}
      </p>
      @if(!last) {
      <div
        class="desktop-hidden h-[1.25rem] w-[0.125rem] bg-vinciBlue-600 rounded-xl"
      ></div>
      }
    </div>
    }
  </div>
  <div class="flex flex-col sm:flex-row justify-between sm:gap-0 gap-2">
    <app-button
      [text]="'components.journeyBreadcrumbs.buttonPrevious' | transloco"
      [variant]="'tertiary'"
      [icon]="'arrow-left'"
      [iconPosition]="'left'"
      (buttonClick)="goToPreviousStep()"
    ></app-button>
    <app-button
      [text]="'components.journeyBreadcrumbs.buttonNext' | transloco"
      [variant]="'secondary'"
      [icon]="'arrow-right'"
      [disabled]="isTheLastPage()"
      (buttonClick)="goToNextStep()"
    ></app-button>
  </div>
</div>
